import { h } from 'preact';
import { PageCard } from './PageCard';
import styles from './PageList.module.scss';
export function PageList({ pages, loading }) {
    if (loading) {
        return (h("div", { class: styles.pageList },
            h("div", { class: styles.loading }, "Loading pages...")));
    }
    if (pages.length === 0) {
        return (h("div", { class: styles.pageList },
            h("div", { class: styles.emptyState }, "No pages found")));
    }
    return (h("div", { class: styles.pageList }, pages.map((page) => (h(PageCard, { key: page.id, page: page })))));
}
